module.exports = __webpack_public_path__ + "img/logo_white.a4d4be92.png";